import styled from "styled-components";

export const EmptyScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 24px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px dashed #d9e2ec;
  animation: fadeInEmpty 0.4s ease-out;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 992px) {
    min-height: 298px;
  }

  .empty-icon-wrapper {
    background: #f0f4f8;
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    color: #627d98;

    svg {
      width: 32px;
      height: 32px;
    }
  }

  .empty-title {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: #1b1464;
    margin-bottom: 8px;
  }

  .empty-description {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #627d98;
    max-width: 260px;
    line-height: 18px;
    margin: 0;
  }

  @keyframes fadeInEmpty {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
